"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleLayers = exports.smallIconWidth = exports.smallIconSize = exports.smallIconHeight = exports.renderWrapStyle = exports.mediumIconWidth = exports.mediumIconSize = exports.mediumIconHeight = exports.largeIconWidth = exports.largeIconSize = exports.largeIconHeight = exports.initialState = exports.buildCustomControl = exports.WEATHER_LAYERS = exports.TRAFFIC_LAYERS = exports.OTHER_OPTIONS = exports.MOBILE_OPTIMIZATION_META_TAG = exports.MAP_ZOOM = exports.MAP_CONTAINER_ID = exports.MAP_CENTER = exports.HERE_SCRIPT_VERSION_PATH = exports.HERE_SCRIPT_VERSION_NUMBER = exports.HERE_SCRIPT_UI_URI = exports.HERE_SCRIPT_UI_STRING = exports.HERE_SCRIPT_ROOT_URI = exports.HERE_SCRIPT_HARP_STRING = exports.HERE_SCRIPT_HARP = exports.HERE_SCRIPT_DOMAIN = exports.HERE_SCRIPT_BUNDLE_URI = exports.HERE_SCRIPT_BUNDLE_STRING = exports.DEFAULT_HMAP_CONFIG = exports.API_KEY = void 0;
// models & interfaces

// constants 

/****************************************************** 
    STYLE VALUES 
 *****************************************************/
var renderWrapStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  width: "100%"
};

/****************************************************** 
    HERE MAPS API VALUES
 *****************************************************/
// A temporary API KEY which should no longer be placed here when the component is ready for production
exports.renderWrapStyle = renderWrapStyle;
var API_KEY = __HERE_API_KEY__;
exports.API_KEY = API_KEY;
var HERE_SCRIPT_DOMAIN = "https://js.api.here.com";
exports.HERE_SCRIPT_DOMAIN = HERE_SCRIPT_DOMAIN;
var HERE_SCRIPT_VERSION_PATH = "v3";
exports.HERE_SCRIPT_VERSION_PATH = HERE_SCRIPT_VERSION_PATH;
var HERE_SCRIPT_VERSION_NUMBER = 3.1;
exports.HERE_SCRIPT_VERSION_NUMBER = HERE_SCRIPT_VERSION_NUMBER;
var HERE_SCRIPT_BUNDLE_STRING = "mapsjs.bundle.js";
exports.HERE_SCRIPT_BUNDLE_STRING = HERE_SCRIPT_BUNDLE_STRING;
var HERE_SCRIPT_HARP_STRING = "mapsjs-harp.js";
exports.HERE_SCRIPT_HARP_STRING = HERE_SCRIPT_HARP_STRING;
var HERE_SCRIPT_UI_STRING = "mapsjs-ui.css";
exports.HERE_SCRIPT_UI_STRING = HERE_SCRIPT_UI_STRING;
var HERE_SCRIPT_ROOT_URI = "".concat(HERE_SCRIPT_DOMAIN, "/") + "".concat(HERE_SCRIPT_VERSION_PATH, "/") + "".concat(HERE_SCRIPT_VERSION_NUMBER, "/");
exports.HERE_SCRIPT_ROOT_URI = HERE_SCRIPT_ROOT_URI;
var HERE_SCRIPT_BUNDLE_URI = "".concat(HERE_SCRIPT_ROOT_URI) + "".concat(HERE_SCRIPT_BUNDLE_STRING);
exports.HERE_SCRIPT_BUNDLE_URI = HERE_SCRIPT_BUNDLE_URI;
var HERE_SCRIPT_HARP = "".concat(HERE_SCRIPT_ROOT_URI) + "".concat(HERE_SCRIPT_HARP_STRING);
exports.HERE_SCRIPT_HARP = HERE_SCRIPT_HARP;
var HERE_SCRIPT_UI_URI = "".concat(HERE_SCRIPT_ROOT_URI) + "".concat(HERE_SCRIPT_UI_STRING);

// A meta tag recommended by the HERE maps documentation to improve performance on mobile devices
exports.HERE_SCRIPT_UI_URI = HERE_SCRIPT_UI_URI;
var MOBILE_OPTIMIZATION_META_TAG = "initial-scale=1.0, width-device-width";

/****************************************************** 
    MAP VALUES 
 *****************************************************/

// The id of the HTML element used to host the Here Map
exports.MOBILE_OPTIMIZATION_META_TAG = MOBILE_OPTIMIZATION_META_TAG;
var MAP_CONTAINER_ID = "mapContainer";

// initial component state
exports.MAP_CONTAINER_ID = MAP_CONTAINER_ID;
var initialState = {
  platform: null,
  map: null,
  ui: null,
  scriptLoaded: false,
  mapLoadError: null,
  markerGroup: null
};

// The default zoom level of the map
exports.initialState = initialState;
var MAP_ZOOM = 7;

// The default center of the map
exports.MAP_ZOOM = MAP_ZOOM;
var MAP_CENTER = {
  lat: 32.913149,
  lng: -86.720205
};

// The default mapConfig object
exports.MAP_CENTER = MAP_CENTER;
var DEFAULT_HMAP_CONFIG = {
  center: MAP_CENTER,
  zoom: MAP_ZOOM,
  showSpeeds: false
};

// Default HereMap Marker sizes
exports.DEFAULT_HMAP_CONFIG = DEFAULT_HMAP_CONFIG;
var smallIconWidth = 20;
exports.smallIconWidth = smallIconWidth;
var smallIconHeight = 20;
exports.smallIconHeight = smallIconHeight;
var smallIconSize = {
  w: smallIconWidth,
  h: smallIconHeight
};
exports.smallIconSize = smallIconSize;
var mediumIconWidth = 32;
exports.mediumIconWidth = mediumIconWidth;
var mediumIconHeight = 32;
exports.mediumIconHeight = mediumIconHeight;
var mediumIconSize = {
  w: mediumIconWidth,
  h: mediumIconHeight
};
exports.mediumIconSize = mediumIconSize;
var largeIconWidth = 48;
exports.largeIconWidth = largeIconWidth;
var largeIconHeight = 48;
exports.largeIconHeight = largeIconHeight;
var largeIconSize = {
  w: largeIconWidth,
  h: largeIconHeight
};

// Names of the Traffic Layers for MapToolbox
exports.largeIconSize = largeIconSize;
var TRAFFIC_LAYERS = ["Cameras", "Construction", "Crashes", "Incidents", "Events", "Facilities", "Ferries", "Signs"];

// Names of the Weather Layers for MapToolbox
exports.TRAFFIC_LAYERS = TRAFFIC_LAYERS;
var WEATHER_LAYERS = ["NWS Alerts", "Road Closures"];

// Names of the Other Options for MapToolbox
exports.WEATHER_LAYERS = WEATHER_LAYERS;
var OTHER_OPTIONS = ["Auto Refresh", "Speeds"];
exports.OTHER_OPTIONS = OTHER_OPTIONS;
var toggleLayersLabelStyle = "display: flex;" + "justify-content: center;" + "align-items: center;" + "width: 100%;" + "height: 100%;";
var toggleLayersIconStyle = "color: green;" + "font-size: 1rem;" + "margin-right: 1rem;";
var toggleLayersTextStyle = "display: flex;" + "justify-content: center;" + "align-items: center;" + "color: rgba(0,0,0,.5);" + "font-size: 1rem;" + "font-weight: bold;";
var toggleLayersButtonHtml = "<div style=\"".concat(toggleLayersLabelStyle, "\">\n        <i class=\"fas fa-layer-group\" style=\"").concat(toggleLayersIconStyle, "\"></i>\n        <div style=\"").concat(toggleLayersTextStyle, "\">Layers</div>\n    </div>");
var toggleLayers = function toggleLayers(e, callback) {
  if (e.currentTarget.getState() === "down") {
    callback();
  }
};
exports.toggleLayers = toggleLayers;
var buildCustomControl = function buildCustomControl(config) {
  if (!window.H) return null;
  var H = window.H;
  var newControl = new H.ui.Control();
  newControl.setAlignment(config.alignment || H.ui.LayoutAlignment.TOP_CENTER);
  var button = new H.ui.base.Button({
    'label': config.buttonHtml || toggleLayersButtonHtml,
    'onStateChange': function onStateChange(e) {
      toggleLayers(e, config.callback);
    }
  });
  button.addClass(config.buttonClass || "H-toggle-layers");
  newControl.addChild(button);
  return newControl;
};

/* map 'theme' schemes
    <scheme id="normal.day" />
    <scheme id="normal.day.grey" />
    <scheme id="normal.day.transit" />
    <scheme id="normal.day.custom" />
    <scheme id="normal.night" />
    <scheme id="normal.night.grey" />
    <scheme id="pedestrian.day" />
    <scheme id="pedestrian.night" />
    <scheme id="carnav.day.grey" />
    <scheme id="normal.day.mobile" />
    <scheme id="normal.day.grey.mobile" />
    <scheme id="normal.day.transit.mobile" />
    <scheme id="normal.night.mobile" />
    <scheme id="normal.night.grey.mobile" />
    <scheme id="reduced.day" />
    <scheme id="terrain.day" />
    <scheme id="satellite.day" />
    <scheme id="hybrid.day" />
    <scheme id="terrain.day.mobile" />
    <scheme id="hybrid.day.mobile" />
*/
exports.buildCustomControl = buildCustomControl;